import CustomPopover from "../../../elements/Native/CustomPopover";

const NavtopProfile = ({ userInfo, handleLogout }) => {
  return (
    <CustomPopover
      name={
        <button type="button" className="dashboard-profile-trigger" aria-label="Open profile menu">
          <span>
            {userInfo?.firstName?.slice(0, 1)?.toUpperCase()}
          </span>
          <div>
            <strong>{userInfo?.firstName}</strong>
            <small>
              {userInfo?.role === "ROLE_ADMIN"
                ? "Administrator"
                : userInfo?.role === "ROLE_SUPER_ADMIN"
                ? "Super Admin"
                : "Merchant"}
            </small>
          </div>
        </button>
      }
      width="w-56"
    >
      <div className="dashboard-popover">
        <div className="flex items-center p-4 border-b border-zinc-100">
          <div className="w-9 h-9 bg-primary/10 rounded-full flex items-center justify-center shrink-0">
            <span className="text-primary font-bold text-sm">
              {userInfo?.firstName?.slice(0, 1)?.toUpperCase()}
            </span>
          </div>
          <div className="ml-3 overflow-hidden">
            <h3 className="text-zinc-800 font-semibold text-sm truncate">
              {userInfo?.firstName} {userInfo?.lastName}
            </h3>
            <p className="text-xs text-zinc-400 truncate">{userInfo?.email}</p>
          </div>
        </div>
        <div className="p-2">
          <button
            onClick={handleLogout}
            className="w-full text-left px-3 py-2 text-sm text-red-500 hover:bg-red-50 rounded-md transition-colors font-medium"
          >
            Sign out
          </button>
        </div>
      </div>
    </CustomPopover>
  );
};

export default NavtopProfile;
